$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p === "organizer_product_category_link" && a === "list") {
    //Get Modal for Sub Product Category
    let sub_product_category_modal_lock = false;
    $(document).on("click", "#sub-product-category-new-button", function () {
      let locationId = $("body").attr("event_id");
      const productCategoryId = $(this).attr("data-product-category-id");
      getSubProductCategoryModal(locationId, null, productCategoryId);
    });
    // update
    $(document).on("click", ".sub-product-category-update-button", function () {
      let locationId = $("body").attr("event_id");
      let subProductCategoryId = $(this).attr("data-sub-product-category-id");
      let productCategoryId = $(this).attr("data-product-category-id");
      getSubProductCategoryModal(locationId, subProductCategoryId, productCategoryId);
    });
    function getSubProductCategoryModal(locationId, subProductCategoryId = null, productCategoryId = null) {
      if ($("#sub-product-category-registration-form-modal").length) {
        $("#sub-product-category-registration-form-modal").remove();
      }

      if (!sub_product_category_modal_lock) {
        sub_product_category_modal_lock = true;
        $.ajax({
          type: "POST",
          url: "/ajax/organizer_product_category_link/get_modal",
          data: {
            location_id: locationId,
            sub_product_category_id: subProductCategoryId,
            product_category_id: productCategoryId,
          },
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              $("#content").append(data.html);
              $("#sub-product-category-registration-form-modal").modal("show");
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
            sub_product_category_modal_lock = false;
          })
          .always(function () {
            sub_product_category_modal_lock = false;
          });
      }
      return false;
    }
    //Register or Update SubCategory
    //sub-product-category-registration-button

    let sub_product_category_new_ajax_lock = false;

    $(document).on(
      "click",
      "#sub-product-category-registration-button",
      function (e) {

        e.preventDefault();
        if (
          $(
            "#sub-product-category-registration-form input[name=sub_product_category_id]"
          ).length
        ) {
          let currentColor = $("#sub-product-category-registration-form").attr(
            "data-current-color"
          );
          let updatedColor = $(".product-category-color-picker").val();

          if (currentColor == updatedColor) {
            $("#sub-product-category-registration-form").trigger("submit");
          } else {
            //show warning
            $("#background-color-warning").modal("show");
          }
        } else {
          $("#sub-product-category-registration-form").trigger("submit");
        }
      }
    );

    $(document).on("click", "#background-color-warning-confirm", function () {
      $("#sub-product-category-registration-form").trigger("submit");
    });

    $(document).on("click", "#background-color-warning-cancle", function () {
      $("#sub-product-category-registration-form").modal("hide");
    });

    $(document).on(
      "submit",
      "#sub-product-category-registration-form",
      function () {
        if (!sub_product_category_new_ajax_lock) {
          sub_product_category_new_ajax_lock = true;
          let url;
          if (
            $(
              "#sub-product-category-registration-form input[name=sub_product_category_id]"
            ).length
          ) {
            url = "/ajax/organizer_product_category_link/update_sub_product_category";
          } else {
            url = "/ajax/organizer_product_category_link/new_sub_product_category";
          }

          const disabledOnClick = $("#sub-product-category-registration-button");
          const btnWidth = disabledOnClick.outerWidth();
          disabledOnClick.css("width", btnWidth + "px");
          disabledOnClick.prop("disabled", true);
          disabledOnClick.html(
            '<i class="spinner-border spinner-border-sm"></i>'
          );

          $.ajax({
            type: "POST",
            url: url,
            data: {
              serialized_post: $(this).serialize(),
            },
          })
            .done(function (data) {
              disabledOnClick.prop("disabled", false);
              disabledOnClick.html("Lagre");
              if (data.html !== undefined && data.html !== null) {
                popupAlert();
                $("#sub-product-category-list").empty();
                $("#sub-product-category-list").append(data.html);

                if (
                  $("#show-deactivated-sub-product-category-button").hasClass(
                    "d-none"
                  )
                ) {
                  $("#show-deactivated-sub-product-category-button").removeClass(
                    "d-none"
                  );
                }
                $("#sub-product-category-registration-form-modal").modal("hide");
                $("#background-color-warning").modal("hide");
                $("#background-color-warning").css("display", "none !mportant");

                let subProductCategory = document.getElementById(
                  "sub-product-category-list-sortable"
                );
                Sortable.create(subProductCategory, {
                  handle: ".sub-product-category-reorder",
                  animation: 150,
                  sort: true,
                  delay: 0,
                  touchStartThreshold: 0,
                  disabled: false,
                  draggable: ".sub-product-category",
                  direction: "horizontal",
                  ghostClass: "sortable-ghost",
                  dataIdAttr: "data-sub-product-category-id",
                  removeCloneOnHide: true,
                  store: {
                    set: function (sortable) {
                      let order = sortable.toArray();
                      ajaxListOrder(order);
                    },
                  },
                });
              }
            })
            .fail(function (data) {
              disabledOnClick.prop("disabled", false);
              disabledOnClick.html("Lagre");
              if (
                data.responseJSON.redirect_url !== undefined &&
                data.responseJSON.redirect_url !== null
              ) {
                document.location.href = data.responseJSON.redirect_url;
              }

              if (
                data.responseJSON.error_message !== undefined &&
                data.responseJSON.error_message !== null
              ) {
                prependAlert(
                  "#sub-product-category-registration-button-wrapper",
                  data.responseJSON.error_message,
                  "danger",
                  null,
                  "#sub-product-category-registration-form"
                );
              }

              sub_product_category_new_ajax_lock = false;
            })
            .always(function () {
              sub_product_category_new_ajax_lock = false;
            });
        }

        return false;
      }
    );
    //deactivation
    $(document).on("click", "#show-deactivated-sub-product-category-button", function () {
      if (!$('#show-deactivated-sub-product-category-button').hasClass('d-none')) {
        $('#show-deactivated-sub-product-category-button').addClass('d-none');
      }
      if ($('#deactivated-sub-product-category').hasClass('d-none')) {
        $('#deactivated-sub-product-category').removeClass('d-none');
      }

      let subProductCategory = document.getElementById("sub-product-category-list-sortable");
      Sortable.create(subProductCategory, {
        handle: ".sub-product-category-reorder",
        animation: 150,
        sort: true,
        delay: 0,
        touchStartThreshold: 0,
        disabled: false,
        draggable: ".sub-product-category",
        direction: "horizontal",
        ghostClass: "sortable-ghost",
        dataIdAttr: "data-sub-product-category-id",
        removeCloneOnHide: true,
        store: {
          set: function (sortable) {
            let order = sortable.toArray();
            ajaxListOrder(order)
          }
        }
      });

    });
    if ($("#sub-product-category-list").length) {
      let subProductCategory = document.getElementById("sub-product-category-list-sortable");
      if (subProductCategory && subProductCategory.children.length > 0) {
        if (typeof Sortable !== "undefined") {
          Sortable.create(subProductCategory, {
            handle: ".sub-product-category-reorder",
            animation: 150,
            sort: true,
            delay: 0,
            touchStartThreshold: 0,
            disabled: false,
            draggable: ".sub-product-category",
            direction: "horizontal",
            ghostClass: "sortable-ghost",
            dataIdAttr: "data-sub-product-category-id",
            removeCloneOnHide: true,
            store: {
              set: function (sortable) {
                let order = sortable.toArray();
                ajaxListOrder(order)
              }
            }
          });
        } else {
          console.error("SortableJS library is not loaded. Please include SortableJS before this script.");
        }
      }
    }

    function ajaxListOrder($order) {

      $.ajax({
        type: 'POST',
        url: "/ajax/organizer_product_category_link/sub_category_list_sort",
        data: {
          serialized_post: JSON.stringify($order)
        }
      })
        .done(function (data) {

          if (data === true) {
            popupAlert();
          }

        })
        .fail(function (data) {

          if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
            document.location.href = data.responseJSON.redirect_url;
          }

        });

    }


    $("select[name=product_id]").select2({
      theme: "bootstrap4",
    });
    $("body").scrollspy({
      target: "#navbar-product-category",
      offset: 60,
    });
  }
});
